<template>
<div class="ti">
  <div>
    <el-button type="primary text2"  @click="modals" v-if="userJid[0]['id']==9002001">添加轮播图</el-button>
    <el-button type="primary text2"  @click="ggbianj" v-if="userJid[1]['id']==9002002">公告编辑</el-button>
    <div class="search"></div>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">轮播图名称</th>
            <th class="text-left">跳转第三方appid</th>
            <th class="text-left">跳转地址</th>
            <th class="text-left">日期</th>
            <th class="text-left">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.name}}</td>
            <td ><span v-if="item.appids">{{item.appids}}</span><span v-else>--</span></td>
            <td ><span v-if="item.url">{{item.url}}</span><span v-else>--</span></td>
            <td >{{item.date}}</td>
            <td >
              <v-icon style="color: #1867c0;" @click="xiugai( item.id )" v-if="userJid[2]['id']==9002003">mdi-pencil</v-icon>
              <v-icon  style="color: red;" @click="del( item.id )" v-if="userJid[3]['id']==9002004">mdi-pail-outline</v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <!-- 轮播图 -->
    <Modal
        v-model="modal1"
        :ok-text="anxiu"
        width="800"
        title="编辑"
        @on-ok="ok">
        <div>
          <el-form  label-width="100px" :model="dades">
            <el-form-item label="轮播图名称" :rules="[{required: true}]">
              <el-input v-model="dades.name"></el-input>
            </el-form-item>
            <el-form-item label="appid">
              <el-input v-model="dades.appids"></el-input>
              <span>需要跳转第三方小程序时填写</span>
            </el-form-item>
            <el-form-item label="跳转地址">
              <el-input v-model="dades.url"></el-input>
            </el-form-item>
            <el-form-item label="轮播图" :rules="[{required: true}]">
                <el-upload
                    :action="url"
                    list-type="picture-card"
                    :before-upload="upload"
                    :on-remove="remove"
                    :on-success="success"
                    :file-list ="img">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
          </el-form>
        </div>
    </Modal>
    <!-- 公告 -->
    <Modal
        v-model="modal12"
        :ok-text="anxiu"
        width="800"
        title="编辑"
        @on-ok="okgg">
        <div>
          <el-form  label-width="100px" :model="dades">
            <el-form-item label="公告">
                <el-input type="textarea" v-model="dadesgg.notice"></el-input>
            </el-form-item>
          </el-form>
        </div>
    </Modal>
</div>

</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      url:'',
      url1:'',
      img:[],
      defaultcheckedkeys:[],
      defaultcheckedkeyssa:[],
      value: [],
      dades: {
        id:'',
        name:'',
        applets_id:'',
        appid: '',
        carousel: '',
        appids:'',
        url:'',
      },
      dadesgg:{
        applets_id:'',
        appid: '',
        notice:'',
      },
       options: [
        {
          value: '',
          label: ''
        },],
        options1: [
        {
          value: '',
          label: ''
        },],
        opdade:[],
        opdade1:[],
      options2:[],
      value: '',
      value1:'',
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      modal1: false,
      modal12:false,
    }
  },
  //界面没出来前加载
  created() {
    this.userJid = [{id:''},{id:''},{id:''},{id:''}];
    this.$myhttp.get('admin/lavel3?pid=9002',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // console.log(backdata.data);
        if(backdata.data != 1){
          var date = backdata.data;
          date.forEach(item => {
            //本界面权限
            if(item.id == 9002001){
              this.userJid[0]['id'] = item.id;
            }
            if(item.id == 9002002){
              this.userJid[1]['id'] = item.id;
            }
            if(item.id == 9002003){
              this.userJid[2]['id'] = item.id;
            }
            if(item.id == 9002004){
              this.userJid[3]['id'] = item.id;
            }
          });
        }else{
          //本界面权限
          this.userJid = [{id:'9002001'},{id:'9002002'},{id:'9002003'},{id:'9002004'}];
        }
        // console.log(this.userJid)
      });
  },
  // 加载数据
  mounted(){
    this.url = this.$myhttp.defaults.baseURL + "/admin/posts";
    this.url1 = this.$myhttp.defaults.baseURL;

    this.id = this.$route.query.id;
    this.appid = this.$route.query.appid;
    this.dades.applets_id =  this.id;
    this.dades.appid = this.appid;
    this.dadesgg.applets_id =  this.id;
    this.dadesgg.appid = this.appid;


    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    ERP.showLoading()
    this.$Loading.start();
    this.$myhttp.get('admin/getcompanygshu?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.value1 = 0;
        this.$myhttp.get('admin/appletsHome?id=1'+'&ids='+this.id+"&appid="+this.appid,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
          ERP.hideLoading()
        });
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    // 图片上传
    //点击上传
    upload(file){
      if(this.dades.carousel){
        this.$Message.error('只能上传一张');
        return false;
      }
    },
    //移除
    remove(file, fileList){
      this.dades.carousel = '';
    },
    //上传成功
    success(response, file, fileList){
        var img = this.url1+'/storage/'+file.response;
        this.img = [{name:'轮播图',url:img}];
        this.dades.carousel = '/storage/'+file.response;
        console.log(this.dades.carousel)
    },
    // 图片上传结束
    //保存
    ok(){
      if(this.dades.name == ""){
        this.$Message.error('轮播图名称不能为空!');
        return false;
      }
       if(this.dades.carousel == ""){
        this.$Message.error('图片不能为空!');
        return false;
      }
      this.$Loading.start();
      this.$myhttp.post('admin/appletsHomeAdd',this.dades,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[0] == 1){
            this.$myhttp.get('admin/appletsHome?id=1'+'&ids='+this.id+"&appid="+this.appid,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
            });
            this.$Message.success(backdata.data[1]);
            this.dades={
                id:'',
                name:'',
                applets_id:'',
                appid: '',
                carousel: '',
                appids:'',
                url:'',
            };
            this.dades.applets_id =  this.id;
            this.dades.appid = this.appid;
            this.img = [];
          }else{
            if(backdata.data[0] == 2){
              this.$Message.error(backdata.data[1]);
            }else{
              this.$Message.error('编辑失败!');
            }
          }
          this.$Loading.finish();
      });
    },
    //保存公告
    okgg(){
        this.$Loading.start();
        this.$myhttp.post('admin/appletsGgadd',this.dadesgg,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.$Message.success("编辑成功");
          this.$Loading.finish();
      });
    },
    //弹窗添加
    modals(){
      this.anxiu = "保存";
      if(this.dades.id){
        this.dades={
            id:'',
            name:'',
            applets_id:'',
            appid: '',
            carousel: '',
            appids:'',
            url:'',
        };
        this.dades.applets_id =  this.id;
        this.dades.appid = this.appid;
        this.img = [];
      }
      this.modal1 = true;
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/appletsHome?id='+e+'&ids='+this.id+"&appid="+this.appid,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
        ERP.hideLoading()
        });
    },
    //修改查询
    xiugai(e){
      this.$Loading.start();
      this.anxiu="修改";
      this.$myhttp.get('admin/appletsHomeUpdate?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.dades = backdata.data[0][0];
          var img = this.url1+''+this.dades.carousel;
          this.img = [{name:'轮播图',url:img}];
          this.$Loading.finish();
           this.modal1 = true;
      });
    },
    //公告编辑,查询
    ggbianj(){
        this.$Loading.start();
        this.$myhttp.get('admin/appletsAppid?id='+this.id+"&appid="+this.appid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
            if(backdata.data['code'] == 200){
                this.dadesgg = backdata.data[0][0];
            }
            this.$Loading.finish();
            this.modal12=true;
        });
    },
    //轮播图删除
    del(e){
      this.$confirm('此操作将永久删除该权限吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$Loading.start();
          this.$myhttp.post('admin/appletsHomeDelete',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                this.dela = true;
                var t = Date.parse(new Date()) / 1000;//时间戳
                this.$myhttp.get('admin/appletsHome?id=1'+'&ids='+this.id+"&appid="+this.appid,{
                  'Content-Type': 'application/json'
                  }).then(backdata=>{ // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                    this.$Loading.finish();
                });
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
  },

   watch: {
    '$route' (to, from) { //监听路由是否变化
      if(to.path == "/Applets/appletsFitUp"){
        this.url = this.$myhttp.defaults.baseURL + "/admin/posts";
        this.url1 = this.$myhttp.defaults.baseURL;

        this.id = this.$route.query.id;
        this.appid = this.$route.query.appid;
        this.dades.applets_id =  this.id;
        this.dades.appid = this.appid;
        this.dadesgg.applets_id =  this.id;
        this.dadesgg.appid = this.appid;
        // console.log(to.path);
        this.$myhttp.get('admin/appletsHome?id=1'+'&ids='+this.id+"&appid="+this.appid,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
        });
      }
    }
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
</style>
<style>
.el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    line-height: 100px;
    vertical-align: top;
}
.el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    margin: 0 8px 8px 0;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Applets/appletsFitUp.vue